import React, { useState } from "react";
import { Form, Row, Col, Button, Alert } from "react-bootstrap";
import { FaSearch, FaInfoCircle } from "react-icons/fa";
import Header from "../header/header";
import Navvbar from "../header/Navvbar";
import Footer from "../footer";

const PartnerLab = () => {
  const [country, setCountry] = useState("United Kingdom");
  const [searchBy, setSearchBy] = useState("Lab Name");
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = () => {
    // TODO: implement search logic
    alert(`Searching in ${country} by ${searchBy}: ${searchTerm}`);
  };

  return (
    <>
      <Header />
      <Navvbar />
      <br />
      <div style={{ width: "90%" }} className="mx-auto mt-4">
        <h2>Partner Labs</h2>

        <Alert variant="primary" className="d-flex align-items-center">
          <FaInfoCircle className="me-2" />
          You do not have any partner labs. Search for a DDX enabled lab to
          create a new lab partner.
        </Alert>

          <Form>
         <Row className="align-items-center g-2">
            <Col xs={12} sm="auto">
              <Form.Label className="mb-0">Search in</Form.Label>
            </Col>
            <Col xs={12} sm="auto">
              <Form.Select
                value={country}
                onChange={(e) => setCountry(e.target.value)}
              >
                <option>United Kingdom</option>
                <option>United States</option>
                <option>Canada</option>
              </Form.Select>
            </Col>

            <Col xs={12} sm="auto">
              <Form.Label className="mb-0">by</Form.Label>
            </Col>
            <Col xs={12} sm="auto">
              <Form.Select
                value={searchBy}
                onChange={(e) => {
                  setSearchBy(e.target.value);
                  setSearchTerm(""); 
                }}
              >
                <option>Lab Name</option>
                <option>State</option>
                <option>Zipcode</option>
              </Form.Select>
            </Col>

            <Col xs={12} sm={4}>
              {searchBy === "State" ? (
                <Form.Select
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                >
                  <option value="">Select State</option>
                  <option value="London">London</option>
                  <option value="Manchester">Manchester</option>
                  <option value="Birmingham">Birmingham</option>
                  <option value="Leeds">Leeds</option>
                </Form.Select>
              ) : (
                <Form.Control
                  type="text"
                  placeholder={`Enter ${searchBy}`}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              )}
            </Col>

            <Col xs={12} sm="auto">
              <Button style={{backgroundColor:"#004aad",borderColor:"#004aad"}} onClick={handleSearch}>
                <FaSearch />
              </Button>
            </Col>
          </Row>
        </Form>
      </div>

      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <Footer />
      </div>
    </>
  );
};

export default PartnerLab;
